module.exports = __webpack_public_path__ + "static/Compass-3df178faa66fc0c818c3cb5540420a38.webp";